import React, { useEffect, useState } from "react";
import { Shield, Star } from "lucide-react";
import { useLanguage } from "../components/LanguageContext";
import SEO from "../components/SEO";
import ImagePlaceholder from "../components/ImagePlaceholder";
import { isAiImage } from "../lib/utils";

export default function References() {
  const { lang, t } = useLanguage();
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        const response = await fetch("https://api.dev.auxo.dk/public/v2/content/references");
        if (!response.ok) {
          throw new Error(lang === "da" ? "Kunne ikke hente referencer" : "Could not fetch references");
        }
        const data = await response.json();
        setReferences(data.items || []);
      } catch (err) {
        console.error("Fejl ved hentning af referencer:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReferences();
  }, [lang]);

  return (
    <div className="bg-[#FCF9F5] text-stone-900 py-24 font-sans-custom">
      <SEO pageKey="references" />

      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {/* Header */}
        <div className="max-w-3xl space-y-6 mb-20">
          <div className="inline-flex items-center gap-3 border border-stone-300 bg-stone-100 px-4 py-1.5 text-[10px] uppercase tracking-[0.3em] text-stone-800 rounded-none font-medium font-sans-custom">
            <Shield className="h-3.5 w-3.5 text-stone-700" />
            <span>{t.references.badge}</span>
          </div>
          <h1 className="font-display text-3xl sm:text-5xl md:text-6xl uppercase tracking-normal sm:tracking-wide-custom text-stone-900 font-medium">
            {t.references.title}{" "}
            <span className="italic text-stone-600 lowercase font-display normal-case">
              {t.references.title_italic}
            </span>
          </h1>
          <p className="text-sm text-stone-600 leading-relaxed font-light tracking-wide-custom font-sans-custom">
            {t.references.desc}
          </p>
        </div>

        {/* Loading / Error States */}
        {loading ? (
          <div className="flex h-64 items-center justify-center">
            <div className="h-8 w-8 animate-spin border-2 border-stone-800 border-t-transparent rounded-none" />
          </div>
        ) : error ? (
          <div className="border border-red-200 bg-red-50/50 p-6 text-center text-red-600 rounded-none">
            {t.references.error}: {error}.
          </div>
        ) : references.length === 0 ? (
          <div className="border border-stone-200 bg-white p-12 text-center text-stone-500 rounded-none shadow-sm">
            {t.references.empty}
          </div>
        ) : (
          /* Grid of References - Fjernet for nu, skal bruges senere */
          null
          /*
          <div className="grid gap-12 md:grid-cols-2">
            {references.map((ref) => (
              <div
                key={ref.id}
                className="group flex flex-col border border-stone-200 bg-white transition-all duration-500 hover:border-stone-400 rounded-none shadow-sm"
              >
                {/* Image * /}
                <div className="relative aspect-[16/10] overflow-hidden border-b border-stone-200">
                  {ref.image && ref.image[0] && !isAiImage(ref.image[0]) ? (
                    <img
                      src={`${ref.image[0]}?width=800&quality=85&format=auto`}
                      alt={ref.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                  ) : (
                    <ImagePlaceholder icon="fa-light fa-trophy" text={ref.title} />
                  )}
                </div>

                {/* Content * /}
                <div className="p-8 flex-1 flex flex-col justify-between space-y-4">
                  <div className="space-y-4">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 lg:gap-0">
                      <h2 className="font-display text-xl sm:text-2xl tracking-normal sm:tracking-wide-custom text-stone-900 uppercase font-medium">
                        {ref.title}
                      </h2>
                      <div className="flex text-stone-700">
                        <Star className="h-4 w-4 fill-stone-700 text-stone-700" />
                        <Star className="h-4 w-4 fill-stone-700 text-stone-700" />
                        <Star className="h-4 w-4 fill-stone-700 text-stone-700" />
                        <Star className="h-4 w-4 fill-stone-700 text-stone-700" />
                        <Star className="h-4 w-4 fill-stone-700 text-stone-700" />
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-x-4 gap-y-1 text-[10px] uppercase tracking-widest text-stone-500 font-semibold font-sans-custom">
                      {ref.rider && (
                        <span>
                          {t.references.spec_rider}: <strong className="text-stone-800 font-medium">{ref.rider}</strong>
                        </span>
                      )}
                      {ref.achievement && (
                        <span>
                          {t.references.spec_achievement}: <strong className="text-stone-800 font-medium">{ref.achievement}</strong>
                        </span>
                      )}
                    </div>

                    <div
                      className="text-xs leading-relaxed text-stone-600 font-light tracking-wide-custom font-sans-custom prose prose-sm"
                      dangerouslySetInnerHTML={{ __html: ref.description }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          */
        )}
      </div>
    </div>
  );
}
